import { CompositionChart } from '@widgets/compositionChart';
import { Documents } from '@widgets/documents';
import { FundsManager } from '@widgets/fundsManager';
import { ItemList } from '@widgets/itemList';

export const WidgetTypeMap = {
  ItemList,
  CompositionChart,
  FundsManager,
  Documents,
};

export const isSideBySide = (name: string) => {
  switch (name) {
    case 'TradingInfoWidget':
      return true;

    case 'FundManagerWidget':
      return true;

    case 'PriceInfoWidget':
      return true;

    case 'LastYearlyDistributionWidget':
      return true;

    default:
      return false;
  }
};
